"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.IconTooltip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _IconTooltipSt = require("./IconTooltip.st.css");
var _CoreButtonNext = require("../internal/WixUiCoreComponents/components/CoreButtonNext");
var _reactUid = require("react-uid");
var _Tooltip = require("../Tooltip");
var _types = require("../Tooltip/types");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/IconTooltip/IconTooltip.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** An icon that shows a tooltip on focus and on hover. */
class IconTooltip extends React.Component {
  render() {
    const {
      message,
      icon,
      tooltipId,
      tooltipSkin,
      showTooltip,
      onClickOutside,
      tooltipProps,
      'data-hook': dataHook,
      className,
      ...rest
    } = this.props;
    const content = /*#__PURE__*/React.createElement("span", {
      id: tooltipId,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 21
      }
    }, message);
    return /*#__PURE__*/React.createElement(_Tooltip.Tooltip, (0, _extends2.default)({
      className: (0, _IconTooltipSt.st)(_IconTooltipSt.classes.root, {}, className),
      "data-hook": dataHook,
      "aria-live": "polite",
      disabled: !showTooltip,
      content: content,
      appendTo: "scrollParent",
      skin: tooltipSkin,
      shown: showTooltip,
      onClickOutside: onClickOutside,
      disableClickOutsideWhenClosed: true
    }, tooltipProps, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_CoreButtonNext.CoreButtonNext, (0, _extends2.default)({
      className: _IconTooltipSt.classes.button,
      "aria-pressed": showTooltip,
      "aria-labelledby": tooltipId
    }, rest, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: _IconTooltipSt.classes.icon,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 13
      }
    }, icon)), !showTooltip ? /*#__PURE__*/React.createElement("span", {
      id: tooltipId,
      className: _IconTooltipSt.classes.tooltipMessage,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 63,
        columnNumber: 13
      }
    }, message) : null));
  }
}
exports.IconTooltip = IconTooltip;
(0, _defineProperty2.default)(IconTooltip, "displayName", 'IconTooltip');
(0, _defineProperty2.default)(IconTooltip, "defaultProps", {
  message: '',
  icon: undefined,
  tooltipId: (0, _reactUid.uid)(IconTooltip.displayName),
  tooltipSkin: _types.TooltipSkin.Standard,
  showTooltip: false
});
//# sourceMappingURL=IconTooltip.js.map